module.exports = __webpack_public_path__ + "static/media/cloudedbanners_sm2.86810bc6.png";